import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import { SearchModel } from '../search/search.model';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {HttpErrorResponse} from '@angular/common/http';


@Injectable()
export class DigitalAssetsService extends BaseHttpService {

  private rootUrl: string = 'assets';

  postNewAssets(brandId: string, data: any): Observable<any> {
    return of({});
  }

  fetchAssets(brandId: string, id: any): Observable<any> {
    return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}/${id}`)

        .pipe(catchError(this.handleError.bind(this)));
  }

  putAssets(brandId: string, id: any, data: any): Observable<any> {
    const body = JSON.stringify({ data });
    return this.http.put(`${Config.API}/${this.rootUrl}/${brandId}/${id}`, body, {headers: contentHeaders})

        .pipe(catchError(this.handleError.bind(this)));
  }

  getAssetDetails(brandId: string, id: string) {
    return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}/${id}`)

      .pipe(map( (data: any) => {
          if (data.file_size) {
            data.filesize = data.file_size;
          }
          if (data.last_published_at) {
            data.last_published_date = {date: data.last_published_at};
          }
          return data;
      } ),
      catchError(this.handleError.bind(this)));
  }

  getAssetAssignments(brandId: string, id: string, searchModel: SearchModel) {
    const queryString = this.getQueryString(searchModel);
    return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}/${id}/assignment?${queryString}`)

        .pipe(catchError(this.handleError.bind(this)));
  }

  getFilenameAvaliability(brandId: string, fileName: any) {
    return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}/filename-available?filename=${fileName}`)

        .pipe(catchError(this.handleError.bind(this)));
  }

  getFilenamesAvaliability(brandId: string, filenames: Array<string>) {
    const encodedFilenames = filenames.map((name: string) => {
      return encodeURIComponent(name);
    });
    const params = `filenames[]=${encodedFilenames.join('&filenames[]=')}`;
    return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}/filenames-available?${params}`)

        .pipe(catchError(this.handleError.bind(this)));
  }

  postUpdateStatus(brandId: string, assetId: string, status: number): Observable<any> {
    const body = JSON.stringify({status: status});
    return this.http.post(`${Config.API}/${this.rootUrl}/${brandId}/${assetId}/status`, body, {headers: contentHeaders})

        .pipe(catchError(this.handleError.bind(this)));
  }

  deleteAssets(brandId: string, ids: Array<string>, delete_relations: boolean = false, filter?: any): Observable<any> {
    const body = JSON.stringify({ ids, filter, delete_relations });
    return this.delete(
      `${Config.API}/${this.rootUrl}/${brandId}/`,
      body,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }

  postThirdPartyUriAsset(brandId: string, data: any) {
    const body = JSON.stringify({ data });
    return this.http.post(`${Config.API}/${this.rootUrl}/uri/${brandId}/`, body, {headers: contentHeaders})

      .pipe(catchError((err: HttpErrorResponse) => {
        const errorString = Object.values(err.error.errors).join('; ');
        throw new Error(errorString);
      }));
  }

  searchAssets(brandId: string, searchValue: string, status: string = 'working') {
    return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}/${status}/search?search=${searchValue}`)
      .pipe(catchError(this.handleError.bind(this)));
  }

  private getQueryString(searchModel: SearchModel): string {
    const sortCol: string = (searchModel.sortModel) ? searchModel.sortModel.column : '';
    const sortDir: string = (searchModel.sortModel) ? searchModel.sortModel.sort : '';

    const queryString: string =
      'page=' + searchModel.currentPage +
      '&itemsPerPage=' + searchModel.itemsPerPage +
      '&search=' + searchModel.searchValue +
      '&sortCol=' + sortCol +
      '&sortDir=' + sortDir;

    return queryString;
  }

}
